import { Badge as KitBadge, type BadgeColorVariation, type IconName } from '@d-edge/overnight-hotelier-react'
import type { ReactNode } from 'react'

export type Tone = 'neutral' | 'ok' | 'warn' | 'danger' | 'info'

const color: Record<Tone, BadgeColorVariation> = { neutral: 'gray', ok: 'green', warn: 'orange', danger: 'red', info: 'teal' }

interface BadgeProps {
  tone?: Tone
  children: ReactNode
  title?: string
  icon?: IconName
  className?: string
}

export function Badge({ tone = 'neutral', children, title, icon, className }: BadgeProps) {
  return (
    <KitBadge color={color[tone]} iconName={icon} title={title} className={className}>
      {children}
    </KitBadge>
  )
}

/** Picks a tone from a ratio where high is good (success) or bad (closed, errors). */
export function ratioTone(value: number | null | undefined, options: { warnBelow?: number; dangerBelow?: number; warnAbove?: number; dangerAbove?: number }): Tone {
  if (value === null || value === undefined) return 'neutral'
  if (options.dangerBelow !== undefined && value < options.dangerBelow) return 'danger'
  if (options.warnBelow !== undefined && value < options.warnBelow) return 'warn'
  if (options.dangerAbove !== undefined && value > options.dangerAbove) return 'danger'
  if (options.warnAbove !== undefined && value > options.warnAbove) return 'warn'
  return 'ok'
}
